// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__12lcK","errorLogs":"EditorFooter_errorLogs__2ot1X"};